var React = require('react');

function ArrowBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.197 6.275a.667.667 0 0 1 0-.943l.943-.942c.26-.26.682-.26.942 0L8 10.307l5.918-5.917c.26-.26.682-.26.942 0l.943.942c.26.26.26.683 0 .943l-7.33 7.33a.665.665 0 0 1-.474.196.665.665 0 0 1-.472-.195l-7.33-7.33z","fill":"#502314"}));
}

ArrowBottom.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = ArrowBottom;

ArrowBottom.default = ArrowBottom;
